import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const RandomFileTypeIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 21 20" {...props}>
            <path
                d="M11.3333 1.66669H5.49992C5.05789 1.66669 4.63397 1.84228 4.32141 2.15484C4.00885 2.4674 3.83325 2.89133 3.83325 3.33335V16.6667C3.83325 17.1087 4.00885 17.5326 4.32141 17.8452C4.63397 18.1578 5.05789 18.3334 5.49992 18.3334H15.4999C15.9419 18.3334 16.3659 18.1578 16.6784 17.8452C16.991 17.5326 17.1666 17.1087 17.1666 16.6667V7.50002L11.3333 1.66669Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.3333 1.66669V7.50002H17.1666"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
